import Skeleton from "react-loading-skeleton";

 export default function Skeletons(){
    return(
        <Skeleton  count={40}  />
    )
 }